// ─── PHONES DATA ───────────────────────────────────────────────────────────
// To add images: replace null with your image URL, e.g.:
//   image: '/images/samsung-s26-ultra.jpg'          ← file in /public/images/
//   image: 'https://yourcdn.com/samsung-s26.png'    ← external URL

export const PHONES = [
  // ── SAMSUNG ──────────────────────────────────────────────────────────────
  {
    id: 1, brand: 'Samsung', name: 'Galaxy S26 Ultra', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'RED HOT DEAL',
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1249, wasPrice: 1349, save: 3600, term: 36, prepaid: 30999,
  },
  {
    id: 2, brand: 'Samsung', name: 'Galaxy S26', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '100GB RED VIP', data: '50GB Anytime + 50GB Night Owl', minutes: 'Unlimited', onceOff: '30GB',
    price: 1979, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 3, brand: 'Samsung', name: 'Galaxy S26+', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '100GB RED VIP', data: '50GB Anytime + 50GB Night Owl', minutes: 'Unlimited', onceOff: '30GB',
    price: 2129, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 4, brand: 'Samsung', name: 'Galaxy Z Fold7', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1799, wasPrice: null, save: null, term: 36, prepaid: 42999,
  },
  {
    id: 5, brand: 'Samsung', name: 'Galaxy Z Flip7', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 1029, wasPrice: null, save: null, term: 36, prepaid: 24999,
  },
  {
    id: 6, brand: 'Samsung', name: 'Galaxy Z Flip7 FE', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 799, wasPrice: null, save: null, term: 36, prepaid: 18499,
  },
  {
    id: 7, brand: 'Samsung', name: 'Galaxy A57 5G', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'SAVE 3600',
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1249, wasPrice: 1349, save: 3600, term: 36, prepaid: 30999,
  },
  {
    id: 8, brand: 'Samsung', name: 'Galaxy A37 5G', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 399, wasPrice: null, save: null, term: 36, prepaid: 7999,
  },
  {
    id: 9, brand: 'Samsung', name: 'Galaxy A36 5G', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 599, wasPrice: null, save: null, term: 36, prepaid: 14999,
  },
  {
    id: 10, brand: 'Samsung', name: 'Galaxy A26 5G', storage: '128GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'RED HOT DEAL',
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 399, wasPrice: null, save: null, term: 36, prepaid: 7999,
  },
  {
    id: 11, brand: 'Samsung', name: 'Galaxy A06', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'RED FLEXI 170', data: '170 Airtime Value', minutes: null, onceOff: '30GB',
    price: 179, wasPrice: null, save: null, term: 24, prepaid: 1899,
  },
  {
    id: 12, brand: 'Samsung', name: 'Galaxy A16', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 189, wasPrice: null, save: null, term: 36, prepaid: 2999,
  },

  // ── APPLE ─────────────────────────────────────────────────────────────────
  {
    id: 20, brand: 'Apple', name: 'iPhone 17 Pro Max', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'RED HOT DEAL',
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1399, wasPrice: null, save: null, term: 36, prepaid: 29499,
  },
  {
    id: 21, brand: 'Apple', name: 'iPhone 17 Pro', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'RED HOT DEAL',
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1299, wasPrice: 1349, save: 1800, term: 36, prepaid: 27499,
  },
  {
    id: 22, brand: 'Apple', name: 'iPhone 17', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 849, wasPrice: 899, save: 1800, term: 36, prepaid: 19499,
  },
  {
    id: 23, brand: 'Apple', name: 'iPhone 17e', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 599, wasPrice: null, save: null, term: 36, prepaid: 14799,
  },
  {
    id: 24, brand: 'Apple', name: 'iPhone 16e', storage: '128GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'SAVE 3600',
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 399, wasPrice: 499, save: 3600, term: 36, prepaid: 11999,
  },
  {
    id: 25, brand: 'Apple', name: 'iPhone 16', storage: '128GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 679, wasPrice: null, save: null, term: 36, prepaid: 16999,
  },
  {
    id: 26, brand: 'Apple', name: 'iPhone 15', storage: '128GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'RED FLEXI 170', data: '170 Airtime Value', minutes: null, onceOff: '30GB',
    price: 1049, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 27, brand: 'Apple', name: 'iPhone Air (eSIM)', storage: '1TB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'WHILE STOCKS LAST',
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 799, wasPrice: null, save: null, term: 36, prepaid: 24499,
  },

  // ── HONOR ─────────────────────────────────────────────────────────────────
  {
    id: 30, brand: 'HONOR', name: 'Magic V5', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'LIMITED STOCK',
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 999, wasPrice: null, save: null, term: 36, prepaid: 27999,
  },
  {
    id: 31, brand: 'HONOR', name: 'Magic8 Pro', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'NEW',
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 999, wasPrice: null, save: null, term: 36, prepaid: 27999,
  },
  {
    id: 32, brand: 'HONOR', name: 'X9d 5G', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 479, wasPrice: null, save: null, term: 36, prepaid: 10999,
  },
  {
    id: 33, brand: 'HONOR', name: 'X7d 5G', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 429, wasPrice: null, save: null, term: 36, prepaid: null,
  },
  {
    id: 34, brand: 'HONOR', name: '600 Lite 5G', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'NEW ARRIVAL',
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 399, wasPrice: null, save: null, term: 36, prepaid: 5999,
  },
  {
    id: 35, brand: 'HONOR', name: '400 Pro 5G', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'RED HOT DEAL',
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 499, wasPrice: 529, save: 1080, term: 36, prepaid: 12999,
  },

  // ── HUAWEI ────────────────────────────────────────────────────────────────
  {
    id: 40, brand: 'HUAWEI', name: 'Mate X7', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1599, wasPrice: null, save: null, term: 36, prepaid: 46999,
  },
  {
    id: 41, brand: 'HUAWEI', name: 'Mate80 Pro', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 849, wasPrice: null, save: null, term: 36, prepaid: 24999,
  },
  {
    id: 42, brand: 'HUAWEI', name: 'nova 14 Pro', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 529, wasPrice: null, save: null, term: 36, prepaid: 9999,
  },
  {
    id: 43, brand: 'HUAWEI', name: 'nova 14', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 429, wasPrice: null, save: null, term: 36, prepaid: 6999,
  },
  {
    id: 44, brand: 'HUAWEI', name: 'Pura 80', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 799, wasPrice: null, save: null, term: 36, prepaid: 27999,
  },

  // ── VIVO ──────────────────────────────────────────────────────────────────
  {
    id: 50, brand: 'vivo', name: 'X300 Pro', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1579, wasPrice: null, save: null, term: 36, prepaid: 39999,
  },
  {
    id: 51, brand: 'vivo', name: 'X300', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1299, wasPrice: null, save: null, term: 36, prepaid: 30999,
  },
  {
    id: 52, brand: 'vivo', name: 'V70 5G', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'NEW',
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 799, wasPrice: null, save: null, term: 36, prepaid: 19999,
  },
  {
    id: 53, brand: 'vivo', name: 'V70 FE', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'NEW',
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 579, wasPrice: null, save: null, term: 36, prepaid: 13999,
  },
  {
    id: 54, brand: 'vivo', name: 'Y04', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'SAVE 1800',
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 479, wasPrice: 579, save: 1800, term: 36, prepaid: 11999,
  },

  // ── XIAOMI / REDMI ────────────────────────────────────────────────────────
  {
    id: 60, brand: 'Xiaomi', name: 'Redmi Note 15 Pro+', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 499, wasPrice: null, save: null, term: 36, prepaid: 12499,
  },
  {
    id: 61, brand: 'Xiaomi', name: 'Redmi Note 15 Pro', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 389, wasPrice: null, save: null, term: 36, prepaid: 8499,
  },
  {
    id: 62, brand: 'Xiaomi', name: 'Redmi Note 15', storage: '256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 349, wasPrice: null, save: null, term: 36, prepaid: 6999,
  },
  {
    id: 63, brand: 'Xiaomi', name: 'Redmi A7 Pro', storage: '128GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'NEW',
    package: 'RED FLEXI 170', data: '170 Airtime Value', minutes: null, onceOff: '30GB',
    price: 189, wasPrice: null, save: null, term: 36, prepaid: 2899,
  },

  // ── OPPO ──────────────────────────────────────────────────────────────────
  {
    id: 70, brand: 'OPPO', name: 'Find X9 Pro', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'EXCLUSIVE TO VODACOM',
    package: '6GB RED CORE', data: '6GB Anytime', minutes: '250', onceOff: '30GB',
    price: 1399, wasPrice: 1449, save: 1800, term: 36, prepaid: 32999,
  },
  {
    id: 71, brand: 'OPPO', name: 'Reno15 Pro 5G', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 949, wasPrice: null, save: null, term: 36, prepaid: 23999,
  },
  {
    id: 72, brand: 'OPPO', name: 'Reno15 F 5G', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 599, wasPrice: null, save: null, term: 36, prepaid: 16499,
  },
  {
    id: 73, brand: 'OPPO', name: 'A6 Pro 5G', storage: '128GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 499, wasPrice: null, save: null, term: 36, prepaid: 12499,
  },
  {
    id: 74, brand: 'OPPO', name: 'A6x', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'RED FLEXI 170', data: '170 Airtime Value', minutes: null, onceOff: '30GB',
    price: 399, wasPrice: null, save: null, term: 36, prepaid: 8999,
  },

  // ── MOTOROLA ──────────────────────────────────────────────────────────────
  {
    id: 80, brand: 'Motorola', name: 'razr 60 Swarovski Edition', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'LIMITED STOCK',
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 929, wasPrice: null, save: null, term: 36, prepaid: 19999,
  },
  {
    id: 81, brand: 'Motorola', name: 'razr 60', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'LIMITED STOCK',
    package: '3GB RED CORE', data: '3GB Anytime', minutes: '100', onceOff: '30GB',
    price: 769, wasPrice: null, save: null, term: 36, prepaid: 14999,
  },
  {
    id: 82, brand: 'Motorola', name: 'edge 70', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 449, wasPrice: null, save: null, term: 36, prepaid: 9999,
  },

  // ── REALME ────────────────────────────────────────────────────────────────
  {
    id: 90, brand: 'realme', name: 'C75x', storage: '128GB + 256GB',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: '1GB RED CORE TOP UP', data: '1GB Anytime', minutes: '50', onceOff: '30GB',
    price: 289, wasPrice: null, save: null, term: 36, prepaid: 4999,
  },
  {
    id: 91, brand: 'realme', name: 'Note 60x', storage: null,
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    package: 'RED FLEXI 170', data: '170 Airtime Value', minutes: null, onceOff: '30GB',
    price: 179, wasPrice: null, save: null, term: 24, prepaid: 1699,
  },
];

export const PHONE_BRANDS = ['All', ...new Set(PHONES.map(p => p.brand))];
